/**
 * @module app.portal.rankingTaCtrl
 *
 * The var names witch contain loading mean : is a request pending ?
 */

define(['angular', 'lodash'], function(angular, _) {

    function RankingTaCtrl($scope, $rootScope, $uibModal, $log, $sce, authService, commonService, storeService, Notification) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        let self = {};
        self.customerFile = null;
        self.prospectFile = null;
        self.preview = null;
        self.blobURL = null;

        self.getType = (base64) => {
            let type = base64.split(';')[0];
            return type.split('/')[1];
        }

        self.send = function() {
            if(self.customerFile || self.prospectFile){
                self.customerFile = self.customerFile !== null ? self.customerFile.split('base64,')[1] : self.customerFile;
                self.prospectFile = self.prospectFile !== null ? self.prospectFile.split('base64,')[1] : self.prospectFile;
                   if(self.customerFile)
                      storeService.updateMoneyTransfertRanking(self.customerFile, 'customer').then(res => {
                          if(res === 'ok')
                            Notification.success('Fichier customer ' + res);
                      });

                if(self.prospectFile)
                    storeService.updateMoneyTransfertRanking(self.prospectFile, 'prospect').then(res => {
                        if(res === 'ok')
                            Notification.success('Fichier prospect ' + res);
                    });
            }else {
                Notification.error('Vous devez ajouter au moins un des fichiers.')
            }

        };


        self.viewer = function (data){
            self.preview = data.split('base64,')[1];
            const contentType = self.getType(data);
            // console.log(data);
            let blob = null;
            blob = commonService.b64toBlob(self.preview, contentType);
            self.blobURL = $sce.trustAsResourceUrl(URL.createObjectURL(blob) +  '#toolbar=0&navpane=0');
        };


        return self;
    }

    RankingTaCtrl.$inject = ['$scope', '$rootScope', '$uibModal', '$log', '$sce', 'authService', 'commonService', 'storeService', 'Notification'];

    angular.module('app.portal.rankingTaCtrl', ['ui-notification'])
        .controller('RankingTaCtrl', RankingTaCtrl)
        .directive('readfile', [
            function() {
                return {
                    scope: {
                        readfile: '='
                    },
                    link: function(scope, element, attributes) {
                        element.bind('change', function(changeEvent) {
                            var reader = new FileReader();
                            reader.onload = function(loadEvent) {
                                scope.$apply(function() {
                                    scope.readfile = loadEvent.target.result;
                                });
                            };
                            reader.readAsDataURL(changeEvent.target.files[0]);
                        });
                    }
                };
            }
        ]);
});
